import { useFormatCurrencyCallback } from './useFormatCurrencyCallback';

export const useFormatCurrency = (amount: number, currency: string) => {
    const formatCurrency = useFormatCurrencyCallback();

    return formatCurrency(amount, currency);
};
